module.exports = __webpack_public_path__ + "static/media/clanwilliam.9eaea390.png";